




















































































































import {Component, Vue} from "vue-property-decorator";
import LocalDataStore from "../shared/DataService/localDataStore";
import Utils from "@/shared/utils";
import AppSettings from "@/shared/Configuration/appSettings";
import * as _ from "lodash";
import {Plex} from "@/shared/DataService/plex";
import Configuration from "@/shared/Configuration";
import localDataStore from "../shared/DataService/localDataStore";

@Component({})
export default class AdminPage extends Vue {
    settingsFile: any = null;
    dataFile: any = null;
    isNotificationVisible: boolean = false;
    notificationText: string = null;
    notificationTimeout: number = 0;
    notificationColor: string = null;

    public async downloadSettings() {
        const localStorage = new LocalDataStore();
        const settings = await localStorage.getAppSettings();
        const json = Utils.addKnwlInfo(settings.toJson());
        const text = JSON.stringify(json);
        Utils.downloadData(text, "settings", "application/json");
    }

    public async downloadLocalData() {
        const localStorage = new LocalDataStore();
        const localData = await localStorage.getPlex("default");
        const json = Utils.addKnwlInfo(localData.toJson());
        const text = JSON.stringify(json);
        Utils.downloadData(text, "knwl", "application/json");
    }


    async onUploadSettings() {
        try {
            if (!this.validJsonData(this.settingsFile)) {
                return;
            }
            const raw = await this.settingsFile.text();
            const settings = AppSettings.fromString(raw);
            const localStorage = new LocalDataStore();
            await localStorage.upsertAppSettings(settings);
            this.notify("The settings have been imported. This page will reload to apply the new settings.", 3000, "green");
            setTimeout(() => {
                // reload in case theme has changed
                this.$router.go(0);
            }, 3000);
        } catch (e) {
            this.notify("An error occurred, are you sure this is a settings file?", 3000, "red");
        }
    }

    async onUploadData() {
        try {
            if (!this.validJsonData(this.dataFile)) {
                return;
            }
            const raw = await this.dataFile.text();
            const plex = Plex.fromString(raw);
            const localStorage = new LocalDataStore();
            await localStorage.upsertPlex(plex);
            this.notify("The data has been imported. The page will reload to load the data.", 3000, "green");
            setTimeout(() => {
                // reload in case theme has changed
                this.$router.go(0);
            }, 3000);
        } catch (e) {
            this.notify("An error occurred, are you sure this is a data file?", 3000, "red");
        }
    }

    validJsonData(file) {
        if (_.isNil(file)) {
            this.notify("No file selected.", 2000, "red");
            return false;
        }
        return true;
    }

    notify(text: string, timeout: number = 2000, color: string = "white") {
        this.notificationText = text;
        this.notificationTimeout = timeout;
        this.notificationColor = color;
        this.isNotificationVisible = true;
    }

    goHome() {
        this.$router.push({path: "/"});
    }

    async clearLocalData() {
        const store = new localDataStore();
        await store.removePlex("default");
        await Configuration.init(this.$store);
        this.notify("The data has been cleared. The page will reload to reflect this new state.", 3000, "green");
        setTimeout(() => {
            // reload in case theme has changed
            this.$router.go(0);
        }, 3000);
    }
}
